<!-- Barbell glyph — a loaded bar (bar + two plates per side). Sized in `em`
     so it scales with the surrounding font-size and inherits currentColor. -->
<template>
  <svg class="barbell-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       stroke-width="2" stroke-linecap="round" aria-hidden="true">
    <line x1="4" y1="12" x2="20" y2="12" />
    <line x1="6.5" y1="8" x2="6.5" y2="16" />
    <line x1="17.5" y1="8" x2="17.5" y2="16" />
    <line x1="3.5" y1="9.75" x2="3.5" y2="14.25" />
    <line x1="20.5" y1="9.75" x2="20.5" y2="14.25" />
  </svg>
</template>

<style scoped>
.barbell-icon {
  width: 1.05em;
  height: 1.05em;
  display: inline-block;
  vertical-align: -0.14em;
  flex: 0 0 auto;
}
</style>
